import { useEffect, useState } from 'react'
import { useInfiniteQuery } from '@tanstack/react-query'
import { UserRoleParams } from '../services/usersService/getUsersByRole'
import { usersService } from '../services/usersService'
import { useToast } from '@/view/components/ui/use-toast'

export const useUsersByRole = (initialRole: string) => {
  const [params, setParams] = useState<UserRoleParams>({ role: initialRole })
  const { toast } = useToast()

  const handleUsersData = async ({ pageParam = 0 }) => {
    const response = await usersService.getUsersByRole({
      ...params,
      skip: pageParam,
    })

    return response
  }

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetching,
    isFetchingNextPage,
    isError,
  } = useInfiniteQuery({
    queryKey: [
      'usersByRole',
      params?.role,
      params?.managerIds,
      params?.limit,
      params?.sort,
    ],
    queryFn: handleUsersData,
    getNextPageParam: (lastPage) => {
      if (
        lastPage.pagination.skip + lastPage.pagination.limit >=
        lastPage.pagination.total
      ) {
        return null
      }
      return lastPage.pagination.skip + lastPage.pagination.limit
    },
    initialPageParam: 0,
  })

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregar os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
    setParams,
    params,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  }
}
